import { Button, CircularProgress, LinearProgress, Tooltip } from "@mui/material"
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import { useEffect, useState } from "react";
import { IExtracaoTableItem, IStatusProcesso } from "../../../../../application/models";
import { useAppSelector } from "../../../../hooks/store-hooks";
import { useExtracoesService } from "../../../../../use-cases/geo-veles";
import { useProcessoService } from "../../../../../use-cases/geo-veles/processo";
import ReportProblemIcon from '@mui/icons-material/ReportProblem'

export const DownloadCell = (data: {
    extracao: IExtracaoTableItem
}) => {
    // State
    const { extracoes } = useAppSelector((state) => state.extracoes)
    // Use State
    const [itWasPending, setItWasPending] = useState(false)
    const [status, setStatus] = useState<IStatusProcesso>(IStatusProcesso.PENDENTE);
    const [progresso, setProgresso] = useState<number>(0)
    const [fileExist, setFileExist] = useState<boolean>(false)
    // Service
    const { getExtracoes, setExtracaoAberta } = useExtracoesService()
    const { createReprocesso, findProcessoByIdVelesGeoExtracao } = useProcessoService()

    useEffect(() => {
        const interval = setInterval(() => {
            findProcessoByIdVelesGeoExtracao(data.extracao.extracao.IdVelesGeoExtracao)
                .then((response) => {
                    setFileExist(response?.arquivoExiste ?? false)
                    setProgresso(response?.processo.Progresso ?? 0)
                    if (response?.processo.IdVelesGeoStatusProcesso === IStatusProcesso.PROCESSADO) {
                        setStatus(IStatusProcesso.PROCESSADO)

                        if (itWasPending) {
                            getExtracoes()
                            setItWasPending(false)
                        }

                        clearInterval(interval)
                    }

                    if (response?.processo.IdVelesGeoStatusProcesso === IStatusProcesso.PROCESSANDO) {
                        setItWasPending(true)
                        setStatus(IStatusProcesso.PROCESSANDO)
                    }

                    if (response?.processo.IdVelesGeoStatusProcesso === IStatusProcesso.FALHA) {
                        setStatus(IStatusProcesso.FALHA)
                        if (itWasPending) {
                            setItWasPending(false)
                            getExtracoes()
                        }
                        clearInterval(interval)
                    }

                    if (response?.processo.IdVelesGeoStatusProcesso === IStatusProcesso.PENDENTE) {
                        setItWasPending(true)
                        setStatus(IStatusProcesso.PENDENTE)
                    }
                })
        }, 1500)
        return () => clearInterval(interval)
    }, [data.extracao.extracao.IdVelesGeoExtracao, findProcessoByIdVelesGeoExtracao, itWasPending, getExtracoes, extracoes])

    return <>
        {
            status === IStatusProcesso.PROCESSADO &&
            <>
                {
                    fileExist ?
                        <Button
                            key={data.extracao.extracao.IdVelesGeoExtracao}
                            onClick={() => setExtracaoAberta(data.extracao.extracao)}
                        >
                            <DownloadIcon key={data.extracao.extracao.IdVelesGeoExtracao} />
                        </Button>
                        : <>
                            {
                                !itWasPending ?
                                    (
                                        <Button
                                            key={data.extracao.extracao.IdVelesGeoExtracao}
                                            onClick={() => createReprocesso(data.extracao.extracao.IdVelesGeoExtracao)}
                                        >
                                            <RefreshIcon key={data.extracao.extracao.IdVelesGeoExtracao} />
                                        </Button>
                                    )
                                    : <CircularProgress key={data.extracao.extracao.IdVelesGeoExtracao} />
                            }
                        </>
                }
            </>
        }
        {
            status === IStatusProcesso.PROCESSANDO &&
            <>
                <Tooltip title={`${progresso}%`} arrow>
                    <LinearProgress
                        variant="determinate"
                        value={progresso}
                        sx={{ width: '100%' }}
                    />
                </Tooltip>
            </>
        }
        {
            status === IStatusProcesso.PENDENTE &&
            <Tooltip
                title='Aguardando fila'
                placement="top"
            >
                <CircularProgress key={data.extracao.extracao.IdVelesGeoExtracao} />
            </Tooltip>
        }
        {
            status === IStatusProcesso.FALHA &&
            <Tooltip
                title='Falha'
                placement="top"
            >
                <ReportProblemIcon color="primary" />
            </Tooltip>
        }
    </>
}